<button
  mat-button
  cdk-overlay-origin
  #trigger="cdkOverlayOrigin"
  color="accent"
  (click)="open()"
  [disabled]="disabled"
>
  <div class="d-flex align-items-center">
    <span>{{value}}</span>
    <mat-icon svgIcon="chevron-down" class="ml-1"></mat-icon>
  </div>
</button>

<ng-template
  cdk-connected-overlay
  [cdkConnectedOverlayOpen]="isOpen"
  [cdkConnectedOverlayOrigin]="trigger"
  (overlayOutsideClick)="close()"
  cdkConnectedOverlayWidth="300"
>
  <ng-content></ng-content>
</ng-template>